module.exports = __webpack_public_path__ + "img/SOUTHASIA_WHOLE_GRAINS.4375b6c8.png";